import { ADD_TOKEN, CLEAR_TOKEN } from './tokenTypes';

export const setToken = (token) => ({
    type: ADD_TOKEN,
    payload: token
});

export const clearToken = () => ({
    type: CLEAR_TOKEN
});

